module.exports = __webpack_public_path__ + "static/Mateusz_1_min-45da4fca67f7905c94afbf649447a1f3.jpg";